import { render, staticRenderFns } from "./DialogChangeEmail.vue?vue&type=template&id=18c9c914&scoped=true&"
import script from "./DialogChangeEmail.vue?vue&type=script&lang=js&"
export * from "./DialogChangeEmail.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangeEmail.vue?vue&type=style&index=0&id=18c9c914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c9c914",
  null
  
)

export default component.exports